import { validateObjectStructure } from '../../utility';
import { createDBoxPluginStore, createDboxPluginStoreConfig } from './dboxstore';

export const useDBoxStore = () => {
  return {
    props: {
      storeConfig: {
        type: Object,
        required: true,
      },
    },
    mounted() {
      // console.log({ "useDBoxStore": 1 });
      const { valid, errorString } = validateObjectStructure(this.storeConfig, createDboxPluginStoreConfig({}));
      if (!valid) {
        throw Error(`Please Pass in a valid storeConfig object as Props. Error: ${errorString}`);
      }

    },
    data() {
      return {
        DPSCreator: null,
      }
    },
    beforeMount: async function () {
      this.DPSCreator = createDBoxPluginStore(this.$store);
    },
    computed: {
      dboxPluginStore() {
        return this.DPSCreator(this.storeConfig);
      },
      dboxData() {
        return this.dboxPluginStore?.dboxData;
      },
      dboxMetaData() {
        return this.dboxPluginStore?.dboxMetaData || {};
      },
    }
  }
}